import { IErrMsg } from '../../../components/inputs/types'
import {
    INT_RANGE_REGEX,
    MAX_INT_RANGE,
    POSITIVE_INT_REGEX,
    SPACE_AROUND_DASH_REGEX,
} from '../../../components/models/Integer/consts'
import { validateIntegerConstraints } from './helpers'

export function integerRangeErrors(state: any, schema: any): IErrMsg | undefined {
    if (schema.is_required && !state) {
        return { message: 'errors.validation.fieldRequired' }
    }

    if (typeof state !== 'string') {
        return { message: 'errors.validation.invalidValue' }
    }

    if (String(state).includes('e')) {
        return { message: 'errors.validation.integersOnly' }
    }

    const normalized = state.trim().replace(SPACE_AROUND_DASH_REGEX, '-')
    const parsed = parseRange(normalized)

    if (parsed.error) {
        return parsed.error
    }

    for (const value of parsed.values) {
        const error = validateIntegerConstraints(value, schema)
        if (error) {
            return error
        }
    }

    return undefined
}

function parseRange(str: string): { values: bigint[]; error?: IErrMsg } {
    const normalized = str.trim().replace(SPACE_AROUND_DASH_REGEX, '-')

    if (normalized.includes('.')) {
        return {
            values: [],
            error: { message: 'errors.validation.integersOnly' },
        }
    }

    if (POSITIVE_INT_REGEX.test(normalized)) {
        try {
            return { values: [BigInt(normalized)] }
        } catch {
            return {
                values: [],
                error: { message: 'errors.validation.invalidRangeFormat' },
            }
        }
    }

    if (INT_RANGE_REGEX.test(normalized)) {
        try {
            const [startStr, endStr] = normalized.split('-')
            const start = BigInt(startStr)
            const end = BigInt(endStr)

            if (start >= end) {
                return {
                    values: [],
                    error: {
                        message: 'errors.validation.rangeEndGreaterThanStart',
                        values: { start: startStr, end: endStr },
                    },
                }
            }

            const rangeSize = end - start + BigInt(1)
            if (rangeSize > BigInt(MAX_INT_RANGE)) {
                return {
                    values: [],
                    error: {
                        message: 'errors.validation.rangeTooLarge',
                        values: {
                            start: startStr,
                            end: endStr,
                            maxRangeSize: String(MAX_INT_RANGE),
                        },
                    },
                }
            }

            const range: bigint[] = []
            for (let i = start; i <= end; i++) {
                range.push(i)
            }
            return { values: range }
        } catch {
            return {
                values: [],
                error: { message: 'errors.validation.invalidRangeFormat' },
            }
        }
    }

    return {
        values: [],
        error: { message: 'errors.validation.invalidValue' },
    }
}